import React from 'react';
import { Link } from 'react-router-dom';
import Block from '../../assets/Block.json';
import { toast } from 'react-toastify';
import messages from '../../assets/Messages.json';
import { getPreviousAlphabet, alphabetIndex, isHqAsiAdminRole } from '../../Custom/Custom';

export default function BlockHeader({ blockPageInfo, accessBlockIds, savedBlockIds, blockInfo, decode_token }) {
  // console.log("ssssssssss",blockInfo)
  const statusUnitCode = localStorage.getItem('statusUnitCode');
  const shouldSkipValidation = ['4', '5', '7','8'].includes(statusUnitCode) && blockInfo?.surveyYear == '2024';
  const isStatusUnitCode2 = statusUnitCode === '2';
  const isStatusUnitCode3 = statusUnitCode === '3';
  const STATUS2_SECTIONS = ['A', 'B', 'C', 'E', 'L', 'M', 'N'];
  const STATUS3_SECTIONS = ['A', 'B', 'C', 'L', 'M', 'N'];
  const savedIds = Array.isArray(savedBlockIds) ? savedBlockIds : accessBlockIds;
  const roleCodes = decode_token?.id?.ROLE_CODE
    ? String(decode_token.id.ROLE_CODE)
        .split('|')
        .map((r) => String(r).trim())
        .filter(Boolean)
    : [];
  const isHqAsiAdmin = isHqAsiAdminRole(roleCodes);

  const getBlockKey = (item) => item.blockName || `${item.title}${item.section}`;

  const blockAlert = (blockName) => {
    const previewBlock = getPreviousAlphabet(blockName);
    
    if(['4', '5', '7','8'].includes(statusUnitCode)){
      toast.error(`Sorry, you are not allowed to fill data in this Block`,messages.COLOR_RED);
    } else if (isStatusUnitCode2) {
      toast.error(`Please follow sequence A→B→C→E→L→M→N`, messages.COLOR_RED);
    } else if (isStatusUnitCode3) {
      toast.error(`Please follow sequence A→B→C→L→M→N`, messages.COLOR_RED);
    }else{
      toast.error(`Please Save Block ${previewBlock.toUpperCase()} Data`, messages.COLOR_RED);
    }
    
  };

  const getProgressLabel = (item) => item.shortTitle || item.title;

  const processHqBar = (item) => {
    const blockKey = getBlockKey(item);
    const isActive = blockPageInfo?.blockName === blockKey;
    const isAccessible = accessBlockIds.includes(14);
    const label = getProgressLabel(item);

    if (isActive) {
      return (
        <li key={item.id} className="current progressbar-comparison">
          <Link to={item.link}>
            <span>{item.section}</span>
            <strong>{label}</strong>
          </Link>
        </li>
      );
    }

    if (isAccessible) {
      return (
        <li key={item.id} className={`${savedIds.includes(item.id) ? 'active' : ''} progressbar-comparison`}>
          <Link to={item.link}>
            <span>{item.section}</span>
            <strong>{label}</strong>
          </Link>
        </li>
      );
    }

    return (
      <li key={item.id} className="progressbar-comparison">
        <Link to="#" onClick={() => toast.error('Please Save Block N Data', messages.COLOR_RED)}>
          <span>{item.section}</span>
          <strong>{label}</strong>
        </Link>
      </li>
    );
  };

  const processBar=(item)=>{

    const name = getBlockKey(item);
    const isActive = blockPageInfo?.blockName === name;
    const urlAlphabetIndex= alphabetIndex(item.section)
    const isAccessible = accessBlockIds.includes(item.id);
    // Mark as active only when the specific block id is present
    const tempActive = savedIds.includes(item.id);
      return(
        
         (!shouldSkipValidation && !isStatusUnitCode2 && !isStatusUnitCode3) ? (
        isActive ?
          <li  key={item.id} className="current">
          <Link to={item.link}>
            <span>{item.section}</span>
            <strong>{item.title} </strong>
          </Link>
          </li>
          :
          isAccessible   ? 

          <li className={tempActive?"active":''} key={item.id} >
          <Link to={item.link}>
            <span>{item.section}</span>
            <strong>{item.title} </strong>
          </Link>
        </li>

          :
          <li  key={item.id}>
            <Link to="#" onClick={() => blockAlert(item.section)}>
              <span>{item.section}</span>
              <strong>{item.title}</strong>
            </Link>
          </li>
          

      ) : (
        // status 4/5/7/8 special OR status=2/3 special
        isActive && (shouldSkipValidation ? ['A','B','L','M','N'].includes(item.section) : (isStatusUnitCode3 ? STATUS3_SECTIONS.includes(item.section) : STATUS2_SECTIONS.includes(item.section)))?
        <li  key={item.id} className="current">
        <Link to={item.link}>
          <span>{item.section} </span>
          <strong>{item.title} </strong>
        </Link>
        </li>
        :
        isAccessible && (shouldSkipValidation ? ['A','B','L','M','N'].includes(item.section) : (isStatusUnitCode3 ? STATUS3_SECTIONS.includes(item.section) : STATUS2_SECTIONS.includes(item.section)))   ? 

        <li className={tempActive?"active":''} key={item.id} >
        <Link to={item.link}>
          <span>{item.section}</span>
          <strong>{item.title} </strong>
        </Link>
      </li>

        :
        <li  key={item.id}>
          <Link to="#" onClick={() => blockAlert(item.section)}>
            <span>{item.section}</span>
            <strong>{item.title}</strong>
          </Link>
        </li>
      )
      )

  }

  const visibleBlocks = Block.filter((item) => !item.hqOnly || isHqAsiAdmin);
  const progressItemWidth = 100 / visibleBlocks.length;

  return (
    <div className="card mx-3 mb-3">
      <div className="card-body pb-1">
       <div className="row align-items-center">
        <ul id="progressbar" className="mb-3 progressbar-asi-blocks">

        {visibleBlocks.map((item) => {
          if (item.hqOnly) {
            return processHqBar(item);
          }
          return processBar(item);
        })}
        </ul>
       </div>
      </div>
     
   </div>
  );
}
